import React from 'react'
import styled from 'react-emotion'
import Content from 'common/components/Content'
import Button from 'common/components/Button'
import { Title } from 'common/components/Text'
import { color } from 'common/style'
import { connect } from 'react-redux'
import { userSelector } from '../store/selectors/baseSelectors'
import { createBoard } from '../store/actions/boards'
import { createFolder } from '../store/actions/folders'
import { setSidebarSection, toggleSidebar } from '../store/actions/sidebar'
import { BOARDS, FOLDERS } from '../constants'
import { useTranslation } from 'react-i18next'

const Page = styled(({ title, children, toolbar, anon, createBoard, createFolder, className }) => {
  const { t } = useTranslation()
  return (
    <Content className={className}>
      {toolbar}
      <Title>{title}</Title>
      {children}
      {anon ? (
        <span>
          <Page.Button to="#signin">{t('auth.signin')}</Page.Button>
          <Page.Button to="#signup">{t('auth.signup')}</Page.Button>
        </span>
      ) : (
        <span>
          <Page.Button onClick={createBoard}>
            {t('globalNav.createBoard')}
          </Page.Button>
          <Page.Button onClick={createFolder}>
            {t('globalNav.createFolder.button')}
          </Page.Button>
        </span>
      )}
    </Content>
  )
})({
  alignItems: 'center',
  justifyContent: 'center'
})

Page.Button = styled(Button)({
  height: 30,
  display: 'inline-block',
  margin: '40px 7.5px 0',
  padding: '7px 10px'
})

Page.Message = styled.p({
  margin: 0,
  fontSize: 16,
  lineHeight: 1.25,
  textAlign: 'center',
  color: color.grey,
  maxWidth: 320
})

const PageContainer = connect(
  state => {
    const user = userSelector(state)
    return {
      anon: user.isEmpty || user.isAnonymous
    }
  },
  (dispatch, { folderId }) => ({
    createBoard: () => {
      dispatch(createBoard(folderId))
      dispatch(setSidebarSection(BOARDS))
      dispatch(toggleSidebar(true))
    },
    createFolder: () => {
      dispatch(createFolder(folderId))
      dispatch(setSidebarSection(FOLDERS))
      dispatch(toggleSidebar(true))
    }
  })
)

export default PageContainer(Page)
